import "./count-preview.scss";
import BoxContent from "../../BoxContent";
import { useHistory } from "react-router-dom";
import { useDocumentLink } from "../../../statistics/hooks/use-document-link";
import { usePublishDocumentsInfo } from "../../../statistics/hooks/use-publish-document-info";

const CountDocumentPreviewAdmin = () => {
  // const { countComposingDocument, countExternalDocument, countInternalDocument, countPublishedDocument } =
  //   useDocumentsInfo();
  const history = useHistory();
  const { countNeedProcessDocument } = useDocumentLink();
  const {
    countExternalDocument,
    countInternalDocument,
  } = usePublishDocumentsInfo();

  return (
    <div className="count-preview">
      <BoxContent color="more-danger" background="bg-user" onClick={() => history.push("/document?status=needprocess")}>
        <BoxContent.Icon src="/assets/images/document-process.png" />
        <BoxContent.Right>
          <BoxContent.Label>Tài liệu cần xử lý</BoxContent.Label>
          <BoxContent.Count value={countNeedProcessDocument || 0} />
        </BoxContent.Right>
      </BoxContent>

      <BoxContent color="success" background="bg-user" onClick={() => history.push("/document?status=publish")}>
        <BoxContent.Icon src="/assets/images/composing-document.png" />
        <BoxContent.Right>
          <BoxContent.Label>Tài liệu ban hành</BoxContent.Label>
          <BoxContent.Count value={(countExternalDocument ?? 0) + (countInternalDocument ?? 0)} />
        </BoxContent.Right>
      </BoxContent>

      <BoxContent color="info" background="bg-user" onClick={() => history.push("/document")}>
        <BoxContent.Icon src="/assets/images/internal-document.png" />
        <BoxContent.Right>
          <BoxContent.Label>Tài liệu bên ngoài</BoxContent.Label>
          <BoxContent.Count value={countExternalDocument || 0} />
        </BoxContent.Right>
      </BoxContent>

      <BoxContent
        color="danger"
        background="bg-user"
        style={{ width: "100%" }}
        onClick={() => history.push("/document")}
      >
        <BoxContent.Icon src="/assets/images/external-document.png" />
        <BoxContent.Right>
          <BoxContent.Label>Tài liệu nội bộ</BoxContent.Label>
          <BoxContent.Count value={countInternalDocument || 0} />
        </BoxContent.Right>
      </BoxContent>

      <BoxContent
        color="warning"
        background="bg-user"
        style={{ width: "100%" }}
        onClick={() => history.push("/document?status=compose")}
      >
        <BoxContent.Icon src="/assets/images/published-document.png" />
        <BoxContent.Right>
          <BoxContent.Label>Tài liệu đang soạn thảo</BoxContent.Label>
          <BoxContent.Count value={0} />
        </BoxContent.Right>
      </BoxContent>
    </div>
  );
};

export default CountDocumentPreviewAdmin;
